module.exports = __webpack_public_path__ + "media/images/new_landing/about/story-2-94c1740056b751975ece438cc1e723b6.jpg";